import React from 'react'
import BlockedCardListContainer from '../BlockedCardListContainer'
import { useSelector } from 'react-redux'

function BlockedList({ title }) {
    const { user } = useSelector((state) => state.user);

    return (
        <BlockedCardListContainer user={user} matches={user.blocked} title={title} />
    )
}

export default BlockedList